module.exports = __webpack_public_path__ + "img/orange-2.8db766ad.png";